import styled, {css} from "styled-components";
import {BottomNavigationBarMenuItemTextDefaultBox} from "./bottom-navigation-bar-menu-item-text.default.box";


export const BottomNavigationBarMenuItemTextCasino777Box = styled(BottomNavigationBarMenuItemTextDefaultBox)`
  color: ${props => props.theme.colors.text};
  
  ${props => props.isActive && css`
    color: ${props => props.theme.colors.brandPrimary};
    font-weight: 600;
  `}

  &:hover{
    color: ${props => props.theme.colors.brandPrimary};
  }
`;